/* istanbul ignore file */
// libs
import React, { ReactElement } from 'react';
// components
import { Box, Paper, Stack } from '@mui/material';
// context
import { useShowContext } from 'framework/show';
// services
import { getVisibility } from 'framework/utils';
import { ShowPageLayoutWithoutMenuProps } from './ShowPageLayout';
import { pageContentSx, showPageEntityHeaderWrapperSx, showPageHeaderWrapperSx } from '../pageLayoutSx';
import { topButtonsSx } from './topButtonsSx';

const ShowPageLayoutWithoutMenu = ({
  breadcrumbs,
  buttons,
  children,
  entityHeader,
}: ShowPageLayoutWithoutMenuProps) => {
  const { data } = useShowContext();

  return (
    <Paper elevation={0} sx={pageContentSx}>
      {breadcrumbs && <Box mb={3}>{breadcrumbs}</Box>}
      {(entityHeader || buttons) && (
        <Box sx={showPageHeaderWrapperSx}>
          <Box sx={showPageEntityHeaderWrapperSx}>{entityHeader}</Box>
          <Stack sx={topButtonsSx}>
            {buttons &&
              buttons.map(button => {
                const { isVisible: isVisibleProp } = button.props;

                const isVisible = getVisibility(data, isVisibleProp);

                return isVisible ? button : null;
              })}
          </Stack>
        </Box>
      )}
      <Box sx={{ position: 'relative' }}>
        {React.Children.map(children, child => {
          const { isVisible: isVisibleProp } = (child as ReactElement).props;

          const isVisible = getVisibility(data, isVisibleProp);

          return isVisible ? child : null;
        })}
      </Box>
    </Paper>
  );
};

export default ShowPageLayoutWithoutMenu;
